<template>
  <Transition name="slide-fade">
    <div
      v-if="show"
      class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div
        class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all max-w-4xl w-4/6 sm:p-6"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="my-5 font-bold text-center">
          <slot name="header"></slot>
        </div>
        <slot name="main"></slot>
        <div v-if="showButtons" class="mt-5">
          <div>
            <base-button-primary @click="save" class="float-right">
              {{ saveText }}
            </base-button-primary>
          </div>
          <div>
            <base-button-white @click="close" class="float-right mr-3">
              {{ cancelText }}
            </base-button-white>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import BaseButtonWhite from "../buttons/BaseButtonWhite";
import BaseButtonPrimary from "../buttons/BaseButtonPrimary";
export default {
  name: "BaseModal",
  components: { BaseButtonPrimary, BaseButtonWhite },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    saveText: {
      type: String,
      default: "Save",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    showButtons: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save");
    },
  },
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-in;
}
.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
